import { z } from "zod";

/** Lifecycle of a landing-page invite request. "invited" is set after the admin creates the invite. */
export const INVITE_REQUEST_STATUSES = ["new", "invited", "dismissed"] as const;
export const INVITE_REQUEST_LIST_STATUSES = ["new", "all"] as const;

/**
 * Public body for POST /api/invite-requests. Strict, so unknown keys are refused.
 * `website` is a honeypot: real browsers leave it empty, and a non-empty value gets a
 * success response without storing anything.
 */
export const inviteRequestCreateSchema = z
  .object({
    name: z.string().trim().min(1).max(80),
    team: z.string().trim().min(1).max(100),
    email: z.string().trim().toLowerCase().email().max(254),
    message: z.string().trim().max(500).optional(),
    website: z.string().optional(),
  })
  .strict();
export type InviteRequestCreateInput = z.infer<typeof inviteRequestCreateSchema>;

export const inviteRequestListQuerySchema = z
  .object({ status: z.enum(INVITE_REQUEST_LIST_STATUSES).default("new") })
  .strict();

/** One request as the admin queue returns it. Camel-case, like the other admin responses. */
export const adminInviteRequestSchema = z.object({
  id: z.string(),
  name: z.string(),
  team: z.string(),
  email: z.string(),
  message: z.string().nullable(),
  createdAt: z.string(),
  status: z.enum(INVITE_REQUEST_STATUSES),
  handledAt: z.string().nullable(),
  handledBy: z.string().nullable(),
});
export type AdminInviteRequestRow = z.infer<typeof adminInviteRequestSchema>;

/** Response body of the public create: the same for a stored, duplicate or honeypot request. */
export const inviteRequestReceiptSchema = z.object({ received: z.literal(true) });
